import React, { useEffect, useState } from 'react';
import { SelectProps } from '@rio-cloud/rio-uikit/Select';
import { FormattedMessage } from 'react-intl';
import SelectOTA from '~/features/base/components/forms/ota/SelectOTA';
import { useLazyFetchDeliverableVersionsQuery } from '~/api/deliverables/DeliverablesManagement.api';
import { DELIVERABLE_TYPE_BUNDLE } from '~/features/deliverables/constants/deliverablesParameters';
import { toShortSemanticVersion } from '~/features/base/utils/versionNumberConverter';

export const ESSENTIAL_IMAGE_DELIVERABLE_ID = 'essential-image';

interface SelectEssentialImageVersionProps extends Partial<SelectProps<any>> {
    deliverableVersion: any;
    onDeliverableVersionChange: (value: any) => void;
    hasError?: boolean;
    deliverableVersionError?: boolean;
    readOnly?: boolean;
}

const SelectEssentialImageVersion: React.FC<SelectEssentialImageVersionProps> = ({
                                                                                     deliverableVersion,
                                                                                     onDeliverableVersionChange,
                                                                                     hasError,
                                                                                     deliverableVersionError,
                                                                                     readOnly = false,
                                                                                 }) => {

    const [getDeliverableVersions] = useLazyFetchDeliverableVersionsQuery();

    const [deliverableVersions, setDeliverableVersions] = useState<any[]>([]);

    useEffect(() => {
        getDeliverableVersions({
            deliverableId: ESSENTIAL_IMAGE_DELIVERABLE_ID,
            deliverableType: DELIVERABLE_TYPE_BUNDLE.toUpperCase(),
        }).then(result => {
            const versionsList = result?.data?.content.map(version => ({
                label: toShortSemanticVersion(version),
                value: version,
                id: toShortSemanticVersion(version)
            }));
            setDeliverableVersions(versionsList || []);
        });
    }, []);

    const highlightError = (error?: boolean) => error ? 'form-group has-feedback has-error' : '';

    return (
        <div className={`${highlightError(!!hasError && !!deliverableVersionError)}`}>
            <SelectOTA
                title={'intl-msg:essentialImageVersion'}
                placeholder={<FormattedMessage id={'intl-msg:essentialImageVersion'} />}
                useFilter
                useClear
                disabled={readOnly}
                options={deliverableVersions}
                value={deliverableVersion ? [toShortSemanticVersion(deliverableVersion)] : []}
                onChange={(v) => onDeliverableVersionChange(v.value)}
                hasError={deliverableVersionError}
            />
        </div>
    );
};

export default SelectEssentialImageVersion;
